import { makeActionCreator } from '../../../utilities'
import { TimelineConstants } from './timeline.constants'

export const setSegment = makeActionCreator(TimelineConstants.SET_SEGMENT, 'segment')
export const addToActivityLog = makeActionCreator(TimelineConstants.ADD_TO_ACTIVITY_LOG, 'item')
export const addMedicationAdministeredItem = makeActionCreator(TimelineConstants.ADD_MEDICATION_ADMINISTERED_ITEM)
export const setActivityLog = makeActionCreator(TimelineConstants.SET_ACTIVITY_LOG, 'items')
export const setSaveTimelineResponse = makeActionCreator(TimelineConstants.SET_RESPONSE, 'response')
export const setFilteredItems = makeActionCreator(TimelineConstants.SET_FILTERED_ITEMS, 'filteredItems')
export const clearFilters = makeActionCreator(TimelineConstants.CLEAR_FILTERS)
export const saveTimelineItems = makeActionCreator(TimelineConstants.SAVE_TIMELINE)
export const setMedicationAdministeredItem = makeActionCreator(
  TimelineConstants.SET_ADD_MEDICATION_ADMINISTERED_ITEM,
  'payload'
)
export const addIntubationItem = makeActionCreator(TimelineConstants.ADD_INTUBATION_ITEM)
export const setIntubationItem = makeActionCreator(TimelineConstants.SET_INTUBATION_PROCEDURE_ITEM, 'payload')
export const setCardiacItem = makeActionCreator(TimelineConstants.SET_CARDIAC_PROCEDURE_ITEM, 'payload')
export const addCardiacItem = makeActionCreator(TimelineConstants.ADD_CARDIAC_ITEM)
export const setImagingUltrasoundItem = makeActionCreator(TimelineConstants.SET_IMAGING_ULTRASOUND_ITEM, 'payload')
export const addImagingUltrasoundItem = makeActionCreator(TimelineConstants.ADD_IMAGING_ULTRASOUND_ITEM)
export const addTimesItem = makeActionCreator(TimelineConstants.ADD_TIMES_ITEM)
export const deleteTimelineItem = makeActionCreator(TimelineConstants.DELETE_TIMELINE_ITEM, 'selectedItem')
export const setFiltersChips = makeActionCreator(TimelineConstants.SET_FILTER_CHIPS, 'filterChips')
export const setShowClearFiltersButton = makeActionCreator(
  TimelineConstants.SET_SHOW_CLEAR_FILTER_BUTTON,
  'showClearFiltersButton'
)
export const updateFilteredItems = makeActionCreator(TimelineConstants.UPDATE_FILTERED_ITEMS)
export const setSelectedFilterChipType = makeActionCreator(TimelineConstants.SELECTED_FILTER_CHIP_TYPE)
export const addVitals = makeActionCreator(TimelineConstants.ADD_VITALS)
export const setVitalItem = makeActionCreator(TimelineConstants.SET_VITAL_ITEM, 'payload')
export const setAirwayItem = makeActionCreator(TimelineConstants.SET_AIRWAY_PROCEDURE_ITEM, 'payload')
export const addAirwayItem = makeActionCreator(TimelineConstants.ADD_AIRWAY_ITEM)
export const setProcedureLoaderItem = makeActionCreator(TimelineConstants.SET_PROCEDURE_LOADER, 'procedureLoader')
export const setChildbirthOBItem = makeActionCreator(TimelineConstants.SET_CHILDBIRTHOB_PROCEDURE_ITEM, 'payload')
export const addChildbirthOBItem = makeActionCreator(TimelineConstants.ADD_CHILDBIRTHOB_ITEM)
export const setInitiateIvItem = makeActionCreator(TimelineConstants.SET_INITIATE_IV_PROCEDURE_ITEM, 'payload')
export const addInitiateIvItem = makeActionCreator(TimelineConstants.ADD_INITIATE_IV_ITEM)
export const setImmobilizationItem = makeActionCreator(TimelineConstants.SET_IMMOBILIZATION_PROCEDURE_ITEM, 'payload')
export const addImmobilizationItem = makeActionCreator(TimelineConstants.ADD_IMMOBILIZATION_ITEM)
export const setMedicalConsultItem = makeActionCreator(TimelineConstants.SET_MEDICAL_CONSULT_PROCEDURE_ITEM, 'payload')
export const addMedicalConsultItem = makeActionCreator(TimelineConstants.ADD_MEDICAL_CONSULT_ITEM)
export const setExtricationItem = makeActionCreator(TimelineConstants.SET_EXTRICATION_PROCEDURE_ITEM, 'payload')
export const addExtricationItem = makeActionCreator(TimelineConstants.ADD_EXTRICATION_ITEM)
export const setOperationsItem = makeActionCreator(TimelineConstants.SET_OPERATIONS_PROCEDURE_ITEM, 'payload')
export const addOperationsItem = makeActionCreator(TimelineConstants.ADD_OPERATIONS_ITEM)
export const setRescueItem = makeActionCreator(TimelineConstants.SET_RESCUE_PROCEDURE_ITEM, 'payload')
export const addRescueItem = makeActionCreator(TimelineConstants.ADD_RESCUE_ITEM)
export const setHospitalNotifyItem = makeActionCreator(TimelineConstants.SET_HOSPITAL_NOTIFY_PROCEDURE_ITEM, 'payload')
export const addHospitalNotifyItem = makeActionCreator(TimelineConstants.ADD_HOSPITAL_NOTIFY_ITEM)
export const setWoundCareItem = makeActionCreator(TimelineConstants.SET_WOUND_CARE_PROCEDURE_ITEM, 'payload')
export const addWoundCareItem = makeActionCreator(TimelineConstants.ADD_WOUND_CARE_ITEM)
export const setVentilatorItem = makeActionCreator(TimelineConstants.SET_VENTILATOR_PROCEDURE_ITEM, 'payload')
export const addVentilatorItem = makeActionCreator(TimelineConstants.ADD_VENTILATOR_ITEM)
export const setDrainItem = makeActionCreator(TimelineConstants.SET_DRAIN_PROCEDURE_ITEM, 'payload')
export const addDrainItem = makeActionCreator(TimelineConstants.ADD_DRAIN_ITEM)
export const setTitrateItem = makeActionCreator(TimelineConstants.SET_TITRATE_PROCEDURE_ITEM, 'payload')
export const addTitrateItem = makeActionCreator(TimelineConstants.ADD_TITRATE_ITEM)
export const setActionsList = makeActionCreator(TimelineConstants.SET_ACTIONS_LIST, 'actionsList')
export const addLabsItem = makeActionCreator(TimelineConstants.ADD_LABS_ITEM)
export const addPnProcedureItem = makeActionCreator(TimelineConstants.ADD_PN_PROCEDURE_ITEM, 'payload')

export const setPnMedicationItem = makeActionCreator(TimelineConstants.SET_PN_MEDICATION_ITEM, 'payload')
export const addPnMedicationItem = makeActionCreator(TimelineConstants.ADD_PN_MEDICATION_ITEM)

export const setDeleteVitalsPrompt = makeActionCreator(TimelineConstants.SET_DELETE_VITALS_PROMPT, 'deleteVitalsPrompt')
export const setDeleteParentVitals = makeActionCreator(TimelineConstants.SET_DELETE_PARENT_VITALS, 'deleteParentVitals')

export const resetTimelineState = makeActionCreator(TimelineConstants.RESET_TIMELINE_STATE)
export const setIsEditMode = makeActionCreator(TimelineConstants.SET_IS_EDIT_MODE, 'isEditMode')
export const setEditedKeys = makeActionCreator(TimelineConstants.SET_EDITED_KEYS, 'editedKeys')
export const setEditedItem = makeActionCreator(TimelineConstants.SET_EDITED_ITEM, 'payload')
export const syncPtaWithParentVitals = makeActionCreator(TimelineConstants.SYNC_PTA_WITH_PARENT_VITALS, 'ptaToSync')
export const setDeleteProcedurePrompt = makeActionCreator(
  TimelineConstants.SET_DELETE_PROCEDURE_PROMPT,
  'deleteProcedurePrompt'
)
export const setDeleteProcedure = makeActionCreator(TimelineConstants.SET_DELETE_PROCEDURE, 'deleteProcedure')
export const setBloodProductAdministrationItem = makeActionCreator(
  TimelineConstants.SET_BLOOD_PRODUCT_ADMINISTRATION,
  'payload'
)
export const addBloodProcedureAdministrationItem = makeActionCreator(TimelineConstants.ADD_BLOOD_PRODUCT_ADMINISTRATION)

export const setVentricularAssistDeviceItem = makeActionCreator(
  TimelineConstants.SET_VENTRICULAR_ASSIST_DEVICE,
  'payload'
)
export const addVentricularAssistDeviceItem = makeActionCreator(TimelineConstants.ADD_VENTRICULAR_ASSIST_DEVICE)
export const setCriticalCareItem = makeActionCreator(TimelineConstants.SET_CRITICAL_CARE_PROCEDURE_ITEM, 'payload')
export const addCriticalCareItem = makeActionCreator(TimelineConstants.ADD_CRITICAL_CARE_ITEM)
export const setAssessment = makeActionCreator(TimelineConstants.SET_ASSESSMENT, 'payload')
export const addAssessment = makeActionCreator(TimelineConstants.ADD_ASSESSMENT)
